// extracted by mini-css-extract-plugin
export var button = "_30-1";
export var featuredLink = "_30-4";
export var spinner = "_30-2";
export var spinnerContainer = "_30-3";
export var text = "_30-0";